export default __webpack_public_path__ + "static/media/erik-solheim.71a5afbc.jpg";